import { useContext, useMemo } from "react";

import { useSelector } from "react-redux";
import { ConfigContext } from "../../../../utils/ConfigContext";
import { getOpsColor } from "../../../../utils/helper";
import { LeftArrowIcon, RightArrowIcon } from "../../../Icons";
import {
  StyledArrowButton,
  StyledFooter,
  StyledFooterButtonWrapper,
  StyledSubmitButton,
} from "./Footer-styled";

const translationPath = "screen.popup.actions.";

const Footer = ({
  onPrevClick,
  onNextClick,
  showNext,
  onSubmit,
  isValid,
  isNextActive,
  showSubmit,
  nextTitle,
  isFinal,
  t,
}) => {
  const activeModule = useSelector((state) => state.activeModule);
  const { config } = useContext(ConfigContext);
  const opsColor = useMemo(
    () => getOpsColor(config, activeModule),
    [config, activeModule]
  );
  return (
    <StyledFooter>
      <StyledFooterButtonWrapper>
        <div
          style={{ borderRadius: "4px", overflow: "hidden", display: "flex" }}
        >
          {!isFinal && (
            <>
              <StyledArrowButton
                bg={opsColor ?? "#b21b0c"}
                disable={!onPrevClick}
                onClick={onPrevClick ? onPrevClick : undefined}
              >
                <RightArrowIcon
                  style={{ transform: "rotate(90deg)" }}
                  width={18}
                  color="#FFFFFF"
                />
              </StyledArrowButton>
              <div
                style={{ width: "1px", height: "100%", background: "#F3F3F3" }}
              />
              <StyledArrowButton
                bg={opsColor ?? "#b21b0c"}
                disable={!isNextActive}
                onClick={onNextClick}
              >
                <LeftArrowIcon
                  style={{ transform: "rotate(90deg)" }}
                  width={18}
                  color="#FFFFFF"
                />
              </StyledArrowButton>
            </>
          )}
        </div>
        {(isFinal || showNext) && (
          <StyledSubmitButton
            bg={opsColor}
            disable={!isNextActive}
            onClick={onNextClick}
          >
            {nextTitle}
          </StyledSubmitButton>
        )}
        {showSubmit && (
          <StyledSubmitButton
            bg={opsColor}
            disable={!isValid}
            onClick={onSubmit}
          >
            {t(translationPath + "submit")}
          </StyledSubmitButton>
        )}
      </StyledFooterButtonWrapper>
    </StyledFooter>
  );
};

export default Footer;
